import React from "react";
import { useAppDispatch } from "../../app/hooks";
import { verifyTotp } from "./loginSlice";
import OtpInput from "react-otp-input-rc-17";

export const OtpValidation: React.FC = () => {
  const [otpCode, setOtpCode] = React.useState<string>("");
  const dispatch = useAppDispatch();

  const verifyToken = () => {
    dispatch(verifyTotp(otpCode));
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (otpCode.length === 6) {
        verifyToken();
      }
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h2>Autenticación de 2 factores</h2>
      <p>
        Ingresa el código de 6 dígitos generado por tu aplicación de
        autenticación (Google Authenticator, Authy, etc.).
      </p>
      <div onKeyDown={handleKeyDown}>
        {/* <OtpInput
          renderInput={(props) => (
            <input
              {...props}
              style={{
                width: "25px",
                fontSize: "20px",
                borderRadius: "10px",
                border: "2px solid #000000",
                marginLeft: "5px",
                marginRight: "5px",
                textAlign: "center",
              }}
            />
          )}
          value={otpCode}
          onChange={setOtpCode}
          numInputs={6}
          renderSeparator={<span>-</span>}
        /> */}
        <OtpInput
          inputStyle={{
            background: "#e6e6e6",
            border: "none",
            height: "47px",
            width: "45px",
            borderRadius: "6px",
            marginRight: "7px",
            color: "black",
            fontSize: "25px",
          }}
          containerStyle={{
            marginBottom: "8px",
            marginLeft: "2%",
          }}
          isInputNum={true}
          value={otpCode}
          onChange={setOtpCode}
          numInputs={6}
        />
      </div>
      <button
        className="text-medium text-bold primary-color"
        style={{
          border: "none",
          textAlign: "center",
          borderRadius: "8px",
          background: otpCode.length === 6 ? "#1A617D" : "#A9A9A9",
          paddingTop: "5px",
          paddingBottom: "5px",
          paddingRight: "10%",
          paddingLeft: "10%",
          marginTop: "20px",
        }}
        disabled={otpCode.length < 6}
        onClick={verifyToken}
      >
        Verificar
      </button>
    </div>
  );
};
